// extracted by mini-css-extract-plugin
export default {"btn":"Auth_btn__DW9eN","container":"Auth_container__071t6","logout":"Auth_logout__3JlnA","img":"Auth_img__52Z4s","authLink":"Auth_authLink__Jv+PM","svg":"Auth_svg__0Gq+U"};